<template>
  <v-container>
    <v-layout text-center wrap>
      <v-row no-gutters>
        <v-col cols="12">
          <v-data-table
            dense
            v-model="selected"
            :headers="headers"
            :items="allRadioLog"
            :search="search"
            sort-by="vessel_name"
            class="elevation-1"
            :loading="loading"
            loading-text="Loading... Please wait"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Radio Log</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-text-field
                  v-model="search"
                  append-icon="mdi mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-dialog v-model="dialog" max-width="600px">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on"
                      >New Log</v-btn
                    >
                  </template>
                  <v-card ref="form">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            v-for="header in headers"
                            :key="header.value"
                          >
                            <v-text-field
                              v-if="
                                header.display != false &&
                                  header.value != 'action' &&
                                  header.type != 'select' &&
                                  header.type != 'dateNtime' &&
                                  header.type != 'dateNtimeBerth' &&
                                  header.type != 'dateNtimeDepart' &&
                                  header.type != 'time'
                              "
                              v-model="editedItem[header.value]"
                              :label="header.text"
                              :rules="[
                                () =>
                                  !!editedItem[header.value] ||
                                  'This field is required'
                              ]"
                              :error-messages="errorMessage"
                              required
                            ></v-text-field>
                            <v-autocomplete
                              v-if="header.type === 'select'"
                              :items="vessels"
                              v-model="editedItem[header.id]"
                              item-text="vessel_name"
                              item-value="v_id"
                              :label="header.text"
                              auto-select-first
                              no-data-text="Vessel Not Added"
                              :rules="[
                                () =>
                                  !!editedItem[header.value] ||
                                  'This field is required'
                              ]"
                              :error-messages="errorMessage"
                              required
                            ></v-autocomplete>
                            <v-text-field
                              v-if="header.type === 'time'"
                              :label="header.text"
                              v-model="editedItem[header.value]"
                              :value="current_time"
                              type="time"
                              suffix="GMT"
                            ></v-text-field>
                            <v-menu
                              v-model="menu"
                              v-if="header.type === 'dateNtime'"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="doa"
                                  v-if="header.type === 'dateNtime'"
                                  :label="header.text"
                                  prepend-icon="mdi mdi-calendar"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="doa"
                                @input="menu = false"
                              ></v-date-picker>
                            </v-menu>
                            <v-menu
                              v-model="menu2"
                              v-if="header.type === 'dateNtimeBerth'"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="dateBerth"
                                  v-if="header.type === 'dateNtimeBerth'"
                                  :label="header.text"
                                  prepend-icon="mdi mdi-calendar"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="dateBerth"
                                @input="menu2 = false"
                              ></v-date-picker>
                            </v-menu>
                            <v-menu
                              v-model="menu3"
                              v-if="
                                header.type === 'dateNtimeDepart' &&
                                  editedIndex > -1
                              "
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="dod"
                                  v-if="
                                    header.type === 'dateNtimeDepart' &&
                                      editedIndex > -1
                                  "
                                  :label="header.text"
                                  prepend-icon="mdi mdi-calendar"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="dod"
                                @input="menu3 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn color="blue darken-1" text @click="close"
                        >Cancel</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="save"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.vessel_name="{ item }">
              <tr @click="showActivities(item)">
                {{
                  item.vessel_name
                }}
              </tr>
            </template>
            <template v-slot:item.time_anchored="{ item }">
              <span>{{ item.time_anchored | formatTime }}</span>
            </template>
            <template v-slot:item.doa="{ item }">
              <span>{{ item.doa | formatDate }}</span>
            </template>
            <template v-slot:item.dod="{ item }">
              <span>{{ item.dod | formatDate }}</span>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon
                small
                class="mdi mdi-border-color"
                @click="editItem(item)"
              ></v-icon>
              <!-- <v-icon small class="mdi mdi-delete" @click="deleteItem(item)"></v-icon> -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on"
                    ><v-icon
                      small
                      class="mdi mdi-plus-box"
                      @click="setDepart(item)"
                    ></v-icon
                  ></span>
                </template>
                <span>set as departed</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-col cols="12">
        <ship-activities-data-table
          v-bind:radio_logID="radio_logID"
          v-bind:vessel_name="props_vessel_name"
        />
      </v-col>
    </v-layout>
  </v-container>
</template>
<script>
import ShipActivitiesDataTable from "@/components/ShipActivitiesDataTable";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { EventBus } from "../main";
import moment from "moment";

export default {
  name: "RadioLogDataTable",
  components: {
    ShipActivitiesDataTable
  },
  data: () => ({
    dialog: false,
    show: false,
    menu: false,
    menu2: false,
    menu3: false,
    loading: false,
    doa: new Date().toISOString().substr(0, 10),
    dod: new Date().toISOString().substr(0, 10),
    dateBerth: new Date().toISOString().substr(0, 10),
    current_time: moment().format("HH:mm"),
    search: "",
    selected: [],
    radio_logID: null,
    props_vessel_name: null,
    errorMessage: "",
    formHasError: false,
    headers: [
      {
        text: "Vessel Name",
        align: "left",
        sortable: false,
        value: "vessel_name",
        id: "vessel_id",
        type: "select"
      },
      { text: "Voyage No.", value: "voyage_no" },
      { text: "Date of Arrival", value: "doa", type: "dateNtime" },
      { text: "Time anchored", value: "time_anchored", type: "time" },
      {
        text: "Date & Time Berthed",
        value: "datetime_berthed",
        type: "dateNtimeBerth"
      },
      { text: "Date of Departure", value: "dod", type: "dateNtimeDepart" },
      {
        text: "No. of S to B ",
        value: "no_of_shiftings_to_berth",
        display: false
      },
      {
        text: "No. of S to A ",
        value: "no_of_shiftings_to_anchor",
        display: false
      },
      { text: "Actions", value: "action", sortable: false }
    ],
    rlogs: [],
    vessels: [],
    editedIndex: -1,
    editedItem: {
      vessel_name: "",
      voyage_no: "",
      time_anchored: "",
      datetime_berthed: "",
      no_of_shiftings_to_berth: "",
      no_of_shiftings_to_anchor: "",
      dod: "",
      doa: ""
    },
    defaultItem: {
      vessel_name: "",
      voyage_no: "",
      time_anchored: moment().format("HH:mm"),
      datetime_berthed: "",
      no_of_shiftings_to_berth: "",
      no_of_shiftings_to_anchor: "",
      dod: "",
      doa: ""
    }
  }),

  computed: {
    ...mapGetters("radio_log", ["allRadioLog"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Log" : "Edit Log";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();

      if (val)
        this.$store.dispatch("vessels/fetchVessels").then(res => {
          this.vessels = res;
        });
    }
  },

  mounted() {
    this.loading = true;
    this.$store.dispatch("radio_log/fetchRadioLog").then(() => {
      this.loading = false;
    });
  },

  created() {
    //this.initialize()
  },

  methods: {
    initialize() {
      this.$store.dispatch("radio_log/fetchRadioLog");
    },

    showActivities(item) {
      EventBus.$emit("changeLoadingState", true);
      this.$store
        .dispatch("activities/fetchActivities", item.lr_id)
        .then(() => {
          EventBus.$emit("changeLoadingState", false);
        });

      if (item.lr_id) {
        this.radio_logID = item.lr_id;
        this.props_vessel_name = item.vessel_name;
      }
    },
    setDepart(item) {
      console.log(item);
      this.$swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          "Something went wrong. You either did not set a departure date \n or the vessel has already departed!"
      });
    },

    editItem(item) {
      this.editedIndex = this.allRadioLog.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dateBerth = this.editedItem.dod
        ? moment(this.editedItem.datetime_berthed).format("YYYY-MM-DD")
        : new Date().toISOString().substr(0, 10);
      this.doa = moment(this.editedItem.doa).format("YYYY-MM-DD");
      this.dod = this.editedItem.dod
        ? moment(this.editedItem.dod).format("YYYY-MM-DD")
        : new Date().toISOString().substr(0, 10);
      this.editedItem.time_anchored = moment(
        "01-01-1900, " + item.time_anchored
      ).format("HH:mm");
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.allRadioLog.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.allRadioLog.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.allRadioLog[this.editedIndex], this.editedItem);
      } else {
        let data = {
          datetime_berthed: this.dateBerth,
          doa: this.doa,
          time_anchored: this.editedItem.time_anchored,
          vessel_id: this.editedItem.vessel_id,
          voyage_no: this.editedItem.voyage_no,
          is_departed: 0
        };
        this.$store.dispatch("radio_log/saveRadioLog", data).then(res => {
          if (res.success) {
            this.initialize();
            this.$noty.success(res.success);
          } else {
            this.$noty.warning(res.error);
            return;
          }
        });
      }
      this.close();
    }
  }
};
</script>
